/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Billingaddress1Inputs */

const en__field_billingaddress1 = /** @type {(inputs: _Field_Billingaddress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing Address`)
};

const de__field_billingaddress1 = /** @type {(inputs: _Field_Billingaddress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungsadresse`)
};

/**
* | output |
* | --- |
* | "Billing Address" |
*
* @param {_Field_Billingaddress1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_billingaddress1 = /** @type {((inputs?: _Field_Billingaddress1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Billingaddress1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_billingaddress1(inputs)
	return de__field_billingaddress1(inputs)
});
export { _field_billingaddress1 as "_field_billingAddress" }